export default {
  heading: "帐户关联",
  info: "为提供全方位个人化服务，您可以绑定您的校本专属帐户到个人会员帐户。个人会员帐户由您拥有，可以自行管理帐户及永久检视于教城完整的用户资料及活动纪录而不受升班或转校影响。",
  associateFromHeading: "请输入要关联的帐户的登入名称和密码",
  associatedActiveHeading: "已关联的有效帐户",
  listHeading: "关联的旧有帐户列表",
  label: {
    password: "密码",
    closeBtn: "关闭",
    actions: "动作",
  },
  button: {
    remove: "取消关联",
  },
  validations: {
    passwordIsEmpty: "请输入关联帐户的密码",
    passwordInvalid: "无效的密码格式",
    cityIdIsEmpty: "请输入关联帐户的登入名称",
    cityIdInvalid: "无效的登入名称",
  },
  serverErrors: {
    wrongPasswordOrUserNotFound: "帐户不存在或密码不正确",
    notStudent: "只能关联学生帐户",
    inactiveAssociateAccount: "不能取消此帐户关联",
    alreadyHasActiveAssociation: "已关联学生帐户",
    non_full_member: "您的帐户不能关联其他帐户",
    invalid_relationship_nature: "只能关联学生帐户",
    duplicated_relationship_nature: "不能重複关联",
    not_exist_user_relationship: "不存在此帐户关联",
  },
  confirmDialog: {

    associate: {
      content: "确认关联?",
      confirm: "关联",
      cancel: "取消",
    },
    remove: {
      content: "确认取消关联?",
      confirm: "取消关联",
      cancel: "取消",
    },
  },
};
